import React, { useEffect, useCallback, useState} from 'react';
import TracksDropdown from "components/dropdowns/TracksDropdown.js";
import {connect} from 'react-redux';

const LeafDetaials = ({leaf, sequencerEngine, setLeafDetails}) => { 
    let [track, setTrack] = useState(leaf.track);

    useEffect(() => {
        setTrack(leaf.track);
    }, [leaf, setTrack]);

    const onSelectTrack = useCallback((_track) => {
        leaf.track = _track;
        setTrack(_track);
    }, [leaf, setTrack]);

    return (
        <div className="leaf-details">
          <div onClick={e => setLeafDetails(undefined)} className="delete-btn">x</div>
          Send trigger to track: 
          <TracksDropdown sequencerEngine={sequencerEngine} track={track} onSelectTrack={onSelectTrack}/>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeafDetaials);
